import { render, staticRenderFns } from "./ModalNotificacaoSucessoPssc.vue?vue&type=template&id=6d5249f2&lang=pug"
import script from "./ModalNotificacaoSucessoPssc.vue?vue&type=script&lang=js"
export * from "./ModalNotificacaoSucessoPssc.vue?vue&type=script&lang=js"
import style0 from "./ModalNotificacaoSucessoPssc.vue?vue&type=style&index=0&id=6d5249f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports